import { formatDate } from '../helpers/formatters';
import { Show } from '../../openapi/model';
import { useLang } from '../hooks/useLanguage';
import { getImageUrl } from '../helpers/images';

function EventCard({
    show,
    startTime,
    reservationId,
}: {
    show: Show;
    startTime?: string;
    reservationId: number;
}) {
    const { getI18n, t } = useLang();
    const marketing = show?.marketing || {};

    return (
        <div className="fireknife-event-card">
            <div className="fireknife-event-card__img-box">
                <img
                    className="fireknife-event-card__img"
                    src={getImageUrl(getI18n(marketing.primaryImage, marketing.primaryImageI18n))}
                    alt={getI18n(show.title, show.titleI18n)}
                />
            </div>
            <div className="fireknife-event-card__content">
                {getI18n(show.title, show.titleI18n) && (
                    <h1 className="fireknife-event-card__title">
                        {getI18n(show.title, show.titleI18n)}
                        {getI18n(show.subtitle, show.subtitleI18n) && (
                            <>
                                {' - '}
                                <span className="fireknife-event-card__subtitle">
                                    {getI18n(show.subtitle, show.subtitleI18n)}
                                </span>
                            </>
                        )}
                    </h1>
                )}
                {startTime && (
                    <div className="fireknife-event-card__additional-info">
                        {formatDate(startTime, t('widgetLocale'))}
                    </div>
                )}
                {reservationId && (
                    <div className="fireknife-event-card__additional-info">
                        {t('widgetReservationInfo.reservationId')}: #{reservationId}
                    </div>
                )}
            </div>
        </div>
    );
}

export default EventCard;
